import React, {useState, useEffect} from 'react'
import { Modal, Button } from 'react-bootstrap';
import "./CustomModal.css";
import { formatDateForRecentDevelopments } from '../../services/commonService';
import RenderHtmlFormattedText from './RenderHtmlFormattedText';

export default function CustomModal({title, text, handleClose, isTrending = "", date = "", newType = ""}) {
    return (
        <>
            <Modal size="lg" show="true" onHide={handleClose} centered>
                {/* <Modal.Header style={{borderBottom: 0}} closeButton>
                </Modal.Header> */}

                <Modal.Body className=''>
                    {
                        <div className="recent_dev_wrapper">
                            <div className='recent_dev_block'>
                                <div className='recent_icon_head'>
                                    {isTrending == true && <div className="icon_block">
                                        <img src="/img/fire.png" className="fire_icon" alt="icon" />
                                    </div>}
                                    <div className='recent_head_block'>
                                        <h5 className='recent_head'>
                                            {title}
                                        </h5>                                        
                                    </div>
                                    <Modal.Header style={{borderBottom: 0}} closeButton>
                </Modal.Header>   
                                </div>
                                <div className='para_block'>
                                    <div className="date_company_impact_block mt-2">
                                        <div className="impact_company_block">
                                            <div className="impact_score">
                                                {newType && <p className={`impact_score_text mr-2 mb-0 green_impact`} >
                                                    {newType}
                                                </p>}
                                            </div>
                                        </div>
                                        {date && <span className={`date_italic mr-2`} >
                                            {formatDateForRecentDevelopments(date)}
                                        </span>}
                                    </div>
                                    <hr></hr>
                                    <div className="row mb-3">
                                        <div className="col-md-12 min-height-300">
                                        {/* {text} */}
                                        <RenderHtmlFormattedText htmlContent={text} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </Modal.Body>
            </Modal>
        </>
  )
};